// export const HOST = 'http://localhost:3002'
export const HOST = 'https://api.touchitappstore.com'
// const API_ROOT = 'http://api.touchitappstore.com/api';
